import { render, staticRenderFns } from "./DefectFilter.vue?vue&type=template&id=6e37c198"
import script from "./DefectFilter.js?vue&type=script&lang=js&external"
export * from "./DefectFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports